import React from 'react'
import { LabAppointment } from 'types/appointments'
import { ChakraPrimaryButton } from 'components/Button'
import { RoutePaths } from 'containers/Core/Routes'
import icon from 'assets/images/labs.svg'
import { format, utcToZonedTime } from 'date-fns-tz'
import { Amplitude } from 'utils/amplitude.utils'
import { LabProvider } from 'utils/amplitude.types'
import { Button } from '@chakra-ui/react'

interface LabAppointmentCardProps {
  appointment: LabAppointment
}

const LabAppointmentCard: React.FC<LabAppointmentCardProps> = ({
  appointment,
}) => {
  const {
    labProvider,
    labLocation,
    scheduledAt,
    timezone,
    id,
    confirmationNumber,
    labCode,
  } = appointment

  const modifyAppointment = () => {
    const lab =
      labProvider === 'LabCorp' ? LabProvider.LABCORP : LabProvider.QUEST
    Amplitude.labModifyStart({
      lab_location: labLocation,
      lab_appointment_id: id,
      lab_provider: lab,
      lab_appointment_time: scheduledAt,
      lab_code: labCode,
    })
    window.location.href = `${RoutePaths.LAB_SCHEDULING}?labAppointmentId=${id}&confirmationNumber=${confirmationNumber}`
  }

  const getAppointmentDetails = () => {
    const lab =
      labProvider === 'LabCorp' ? LabProvider.LABCORP : LabProvider.QUEST
    Amplitude.labAppointmentDetailsClick({
      lab_location: labLocation,
      lab_appointment_id: id,
      lab_provider: lab,
      lab_appointment_time: scheduledAt,
      lab_code: labCode,
    })
    window.location.href = `${RoutePaths.LAB_SCHEDULING}?labAppointmentId=${id}`
  }

  // Maybe pull this into a util function later
  const zonedDate = utcToZonedTime(new Date(scheduledAt), timezone)
  const formattedTime = format(zonedDate, 'M/d/yyyy h:mm aaaa zzz', {
    timeZone: timezone,
  })

  const isAppointmentInFuture =
    new Date(scheduledAt).getTime() > new Date().getTime()

  const formattedProvider =
    labProvider === 'LabCorp' ? 'Labcorp' : 'Quest Diagnostics'
  const formattedLocationText = `${formattedProvider}, ${labLocation}`

  return (
    <div className="dashboard-card multi-action-card mb-4 p-3">
      <div className="d-inline-flex align-items-center mb-3">
        <div className="dashboard-card-icon-container">
          <img src={icon} className="dashboard-card-icon" />
        </div>
        <div>
          <p className="fs-7 mb-0">Labwork appointment</p>
        </div>
      </div>
      <p>Appointment time: {formattedTime}</p>
      <p>Location: {formattedLocationText}</p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '1rem',
          marginTop: '2rem',
        }}
      >
        <ChakraPrimaryButton onClick={getAppointmentDetails}>
          Appointment details
        </ChakraPrimaryButton>
        {isAppointmentInFuture && (
          <Button
            variant="link"
            color="var(--blue-dark)"
            fontWeight={400}
            _hover={{ textDecoration: 'underline' }}
            textUnderlineOffset="3px"
            onClick={modifyAppointment}
          >
            Modify appointment
          </Button>
        )}
      </div>
    </div>
  )
}

export default LabAppointmentCard
